import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import AuthLayout from './AuthLayout';
import { Form, Field, Input, Button, ErrorText, Footer } from './AuthForm';
import { useAuth } from '../../contexts/AuthContext';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const redirectTo = location.state?.from?.pathname || '/';

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  async function handleSubmit(e) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await login({ email, password });
      navigate(redirectTo, { replace: true });
    } catch (err) {
      const raw = err?.response?.data?.error;
      const msg =
        typeof raw === 'string' ? raw :
        raw && typeof raw === 'object' ? (raw.message || raw.code || JSON.stringify(raw)) :
        err?.message || 'No se pudo iniciar sesión';
      setError(msg);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <AuthLayout
      eyebrow="OPS://AUTH/INGRESS"
      title="Acceso al sistema"
      subtitle="Identificate para entrar al dossier de campaña."
    >
      <Form onSubmit={handleSubmit} noValidate>
        {error && <ErrorText role="alert">{error}</ErrorText>}
        <Field>
          Email
          <Input
            type="email"
            autoComplete="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="operador@arcana.intel"
          />
        </Field>
        <Field>
          Contraseña
          <Input
            type="password"
            autoComplete="current-password"
            required
            minLength={8}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
          />
        </Field>
        <Button type="submit" disabled={submitting}>
          {submitting ? 'Autenticando…' : 'Iniciar sesión'}
        </Button>
      </Form>
      <Footer>
        ¿Sin credenciales? <Link to="/register">Solicitar acceso</Link>
      </Footer>
    </AuthLayout>
  );
}
